// Translations for the IDCards page (frontend/src/pages/IDCards/IDCards.js)
const idCardsDict = [
  { en: "ID Cards Management", sw: "Usimamizi wa Kadi za Utambulisho" },
  { en: "Manage member ID cards and payments", sw: "Simamia kadi za utambulisho za wanachama na malipo" },
  { en: "Issue New Card", sw: "Toa Kadi Mpya" },
  { en: "Card Status:", sw: "Hali ya Kadi:" },
  { en: "Payment Status:", sw: "Hali ya Malipo:" },
  { en: "Search:", sw: "Tafuta:" },
  { en: "All", sw: "Zote" },
  { en: "Pending", sw: "Inasubiri" },
  { en: "Active", sw: "Inatumika" },
  { en: "Expired", sw: "Imemalizika" },
  { en: "Suspended", sw: "Amesimamishwa" },
  { en: "Lost", sw: "Imepotea" },
  { en: "Replaced", sw: "Imebadilishwa" },
  { en: "Paid", sw: "Kilicholipwa" },
  { en: "Failed", sw: "Imeshindwa" },
  { en: "Name or card number...", sw: "Jina au namba ya kadi..." },
  { en: "No ID Cards Found", sw: "Hakuna Kadi za Utambulisho Zilizopatikana" },
  { en: "Issue new cards to members", sw: "Toa kadi mpya kwa wanachama" },
  { en: "Card #", sw: "Namba ya Kadi" },
  { en: "Member", sw: "Mwanachama" },
  { en: "Member #", sw: "Namba ya Mwanachama" },
  { en: "Type", sw: "Aina" },
  { en: "Issue Date", sw: "Tarehe ya Kutolewa" },
  { en: "Expiry", sw: "Muda wa Mwisho" },
  { en: "Status", sw: "Hali" },
  { en: "Payment", sw: "Malipo" },
  { en: "Amount", sw: "Kiasi" },
  { en: "Actions", sw: "Vitendo" },
  { en: "Confirm Payment", sw: "Thibitisha Malipo" },
  { en: "Print", sw: "Chapisha" },
  { en: "Issue New ID Card", sw: "Toa Kadi Mpya ya Utambulisho" },
  { en: "Select Member *", sw: "Chagua Mwanachama *" },
  { en: "-- Select Member --", sw: "-- Chagua Mwanachama --" },
  { en: "Card Type *", sw: "Aina ya Kadi *" },
  { en: "Standard", sw: "Kawaida" },
  { en: "Basic ID card - TSh 20,000", sw: "Kadi ya kawaida ya utambulisho - TSh 20,000" },
  { en: "Premium", sw: "Premium" },
  { en: "Card with Selcom payment integration - TSh 50,000", sw: "Kadi yenye muunganiko wa malipo ya Selcom - TSh 50,000" },
  { en: "Payment Amount", sw: "Kiasi cha Malipo" },
  { en: "Remarks", sw: "Maoni" },
  { en: "Cancel", sw: "Ghairi" },
  { en: "Issue Card", sw: "Toa Kadi" },
  { en: "Card:", sw: "Kadi:" },
  { en: "Member:", sw: "Mwanachama:" },
  { en: "Amount:", sw: "Kiasi:" },
  { en: "Payment Reference", sw: "Kumbukumbu ya Malipo" },
  { en: "Enter payment reference/receipt number", sw: "Weka kumbukumbu ya malipo/namba ya risiti" },
  { en: "ID card created successfully", sw: "Kadi ya utambulisho imeundwa kwa mafanikio" },
  { en: "Failed to create ID card", sw: "Imeshindwa kuunda kadi ya utambulisho" },
  { en: "Payment confirmed successfully", sw: "Malipo yamethibitishwa kwa mafanikio" },
  { en: "Failed to confirm payment", sw: "Imeshindwa kuthibitisha malipo" },
  { en: "Update card status to", sw: "Badilisha hali ya kadi kuwa" },
  { en: "Card status updated", sw: "Hali ya kadi imesasishwa" },
  { en: "Failed to update status", sw: "Imeshindwa kusasisha hali" },
  { en: "ID Card PDF generated and downloaded successfully", sw: "PDF ya kadi ya utambulisho imetengenezwa na kupakuliwa kwa mafanikio" },
  { en: "Failed to generate card", sw: "Imeshindwa kutengeneza kadi" },
];

export default idCardsDict;
